import type { Currency } from './api/types'

const QUOTE_ORDER: Record<Currency, number> = { EUR: 0, USD: 1, UAH: 2 }

export function accountFxQuote(
  transactionCurrency: Currency,
  accountCurrency: Currency,
): { base: Currency; quote: Currency } {
  return QUOTE_ORDER[transactionCurrency] < QUOTE_ORDER[accountCurrency]
    ? { base: transactionCurrency, quote: accountCurrency }
    : { base: accountCurrency, quote: transactionCurrency }
}

export function amountInAccountCurrency(input: {
  amount: number
  transactionCurrency: Currency
  accountCurrency: Currency
  fxRate: number
}): number {
  const { amount, transactionCurrency, accountCurrency, fxRate } = input
  if (transactionCurrency === accountCurrency) return amount

  const { base } = accountFxQuote(transactionCurrency, accountCurrency)
  const converted = transactionCurrency === base ? amount * fxRate : amount / fxRate
  return Math.round(converted * 100) / 100
}
